var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.rootStyle)},[_c('div',{staticClass:"viewport",style:(_vm.viewportStyle)},[_c('div',{ref:"spacer",style:(_vm.spacerStyle)},[_vm._t("default",null,null,_vm.visibleItems)],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }